<ng-template cdkPortalOutlet></ng-template>



// WEBPACK FOOTER //
// ../../../../../src/cdk/dialog/dialog-container.html